module.exports = __webpack_public_path__ + "static/media/quick_service_layout__.e77ee3a2.png";